<app-table [data]="toolStatusHistory"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [hasTitle]="hasTitle"
           [title]="'admin.tool-history.status-history-table.title' | translate"
           [headerBackgroundColor]="headerBackgroundColor"
           [isMaterial]="false"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'admin.tool-history.status-history-table.columns.toolUid' | translate"
                      [filterPlaceholder]="'admin.tool-history.status-history-table.filter.placeholder.toolUid' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="toolUid">
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.status-history-table.columns.toolName' | translate"
                      [filterPlaceholder]="'admin.tool-history.status-history-table.filter.placeholder.toolName' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="toolName">
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.status-history-table.columns.updatedBy' | translate"
                      [filterPlaceholder]="'admin.tool-history.status-history-table.filter.placeholder.updatedBy' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="updatedBy">
        <ng-template #body
                     let-toolStatusHistory="rowData">
            <span>{{ toolStatusHistory.user.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'admin.tool-history.status-history-table.columns.toolStatus' | translate"
                      [sortable]="true"
                      field="toolStatus">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterStatusList"
                          valueField="value"
                          displayField="name"
                          [emptyText]="'admin.tool-history.status-history-table.filter.placeholder.toolStatus' | translate"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body let-tool="rowData">
            <span class="status-row">
                <app-tooltip *ngIf="tool?.toolStance" type="info" [record]="tool?.toolStance"></app-tooltip>
                {{ tool.toolStatus | translate }}
            </span>
        </ng-template>
    </app-table-column>
    <app-table-column #date
                      [header]="'admin.tool-history.status-history-table.columns.date' | translate"
                      [sortable]="true"
                      field="date">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [appendTo]="'body'"
                                  [placeholder]="'admin.tool-history.status-history-table.filter.placeholder.date' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
</app-table>
